export default __webpack_public_path__ + "locales/sl/Settings.json?hash=49f9e745d7178756d5a5fcb2b50ed055";